export default __webpack_public_path__ + "static/prometheus-5e528e3fac56d896e5ce68c344c5440f.svg";